import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { ROUTES } from '../constants/routes.constants'

/**
 * Wraps a customer-account page. Redirects to /login (the unified
 * entry — see UnifiedLoginPage) if the customer isn't authenticated,
 * preserving the originally-requested path via router state.
 */
export function PrivateRoute({ children }: { readonly children: ReactNode }): JSX.Element {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-text-secondary">
        Loading…
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location.pathname }} replace />
  }

  return <>{children}</>
}
